import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.image-carousel');

  carousels.forEach((carousel) => {
    const ic_swiper = carousel.querySelector('.swiper');

    if (!ic_swiper) return;
    if (carousel.dataset.initialized) return;
    carousel.dataset.initialized = 'true';

    let autoplay = ic_swiper.getAttribute('data-autoplay') === 'true';
    new Swiper(ic_swiper, {
      grabCursor: true,
      spaceBetween: 0,
      slidesPerView: 'auto',
      autoplay: autoplay ? { delay: 3000, disableOnInteraction: true } : false,
      loop: autoplay,
      autoHeight: false,
      pagination: { el: '.swiper-pagination', type: 'fraction' },
      navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
      breakpoints: {
        576: { spaceBetween: 0 },
        1024: { spaceBetween: 0 },
        1400: { spaceBetween: 0 },
        1500: { spaceBetween: 0 },
      },
    });
  });
});